import React, { useState } from 'react';
import { Image, Play } from 'lucide-react';
import { TabButton } from '../../layouts/TabButton';
import PhotoGrid from './PhotoGrid';
import VideoGrid from './VideoGrid';

// Importing original images
import img1 from '../../assets/media/photos/skyford_gallery_photo_1.webp';
import img2 from '../../assets/media/photos/skyford_gallery_photo_2.webp';
import img3 from '../../assets/media/photos/skyford_gallery_photo_3.webp';
import img4 from '../../assets/media/photos/skyford_gallery_photo_4.webp';
import img5 from '../../assets/media/photos/skyford_gallery_photo_5.webp';
import img6 from '../../assets/media/photos/skyford_gallery_photo_6.webp';
import img7 from '../../assets/media/photos/skyford_gallery_photo_7.webp';
import img8 from '../../assets/media/photos/skyford_gallery_photo_8.webp';
import img9 from '../../assets/media/photos/skyford_gallery_photo_9.webp';
import img10 from '../../assets/media/photos/skyford_gallery_photo_10.webp';
import img11 from '../../assets/media/photos/skyford_gallery_photo_11.webp';
import img12 from '../../assets/media/photos/skyford_gallery_photo_12.webp';
import img13 from '../../assets/media/photos/skyford_gallery_photo_13.webp';
import img14 from '../../assets/media/photos/skyford_gallery_photo_14.webp';
import img15 from '../../assets/media/photos/skyford_gallery_photo_15.webp';
import img16 from '../../assets/media/photos/skyford_gallery_photo_16.webp';
import img17 from '../../assets/media/photos/skyford_gallery_photo_17.webp';
import img18 from '../../assets/media/photos/skyford_gallery_photo_18.webp';
import img19 from '../../assets/media/photos/skyford_gallery_photo_19.webp';
import img20 from '../../assets/media/photos/skyford_gallery_photo_20.webp';
import img21 from '../../assets/media/photos/skyford_gallery_photo_21.webp';
import img22 from '../../assets/media/photos/skyford_gallery_photo_22.webp';
import img23 from '../../assets/media/photos/skyford_gallery_photo_23.webp';

// Importing copy/placeholder images
import img1_copy from '../../assets/media/photos/copy/skyford_gallery_photo_1.jpg';
import img2_copy from '../../assets/media/photos/copy/skyford_gallery_photo_2.jpg';
import img3_copy from '../../assets/media/photos/copy/skyford_gallery_photo_3.jpg';
import img4_copy from '../../assets/media/photos/copy/skyford_gallery_photo_4.jpg';
import img5_copy from '../../assets/media/photos/copy/skyford_gallery_photo_5.jpg';
import img6_copy from '../../assets/media/photos/copy/skyford_gallery_photo_6.jpg';
import img7_copy from '../../assets/media/photos/copy/skyford_gallery_photo_7.jpg';
import img8_copy from '../../assets/media/photos/copy/skyford_gallery_photo_8.jpg';
import img9_copy from '../../assets/media/photos/copy/skyford_gallery_photo_9.jpg';
import img10_copy from '../../assets/media/photos/copy/skyford_gallery_photo_10.jpg';
import img11_copy from '../../assets/media/photos/copy/skyford_gallery_photo_11.jpg';
import img12_copy from '../../assets/media/photos/copy/skyford_gallery_photo_12.jpg';
import img13_copy from '../../assets/media/photos/copy/skyford_gallery_photo_13.jpg';
import img14_copy from '../../assets/media/photos/copy/skyford_gallery_photo_14.jpg';
import img15_copy from '../../assets/media/photos/copy/skyford_gallery_photo_15.jpg';
import img16_copy from '../../assets/media/photos/copy/skyford_gallery_photo_16.jpg';
import img17_copy from '../../assets/media/photos/copy/skyford_gallery_photo_17.jpg';
import img18_copy from '../../assets/media/photos/copy/skyford_gallery_photo_18.jpg';
import img19_copy from '../../assets/media/photos/copy/skyford_gallery_photo_19.jpg';
import img20_copy from '../../assets/media/photos/copy/skyford_gallery_photo_20.jpg';
import img21_copy from '../../assets/media/photos/copy/skyford_gallery_photo_21.jpg';
import img22_copy from '../../assets/media/photos/copy/skyford_gallery_photo_22.jpg';
import img23_copy from '../../assets/media/photos/copy/skyford_gallery_photo_23.jpg';

const Media = () => {
  const [activeTab, setActiveTab] = useState("photos");

  const photos = [
    img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
    img11, img12, img13, img14, img15, img16, img17, img18, img19,
    img20, img21, img22, img23
  ];

  const copyPhotos = [
    img1_copy, img2_copy, img3_copy, img4_copy, img5_copy, img6_copy,
    img7_copy, img8_copy, img9_copy, img10_copy, img11_copy, img12_copy,
    img13_copy, img14_copy, img15_copy, img16_copy, img17_copy, img18_copy,
    img19_copy, img20_copy, img21_copy, img22_copy, img23_copy
  ];

  const videos = [
    "https://youtu.be/BLoblsswdAA?si=fTSiUufF92ZSqT_z",
    "https://youtu.be/Dk_vve4fk6A?si=k5MYRL7Dzhi2U2l5",
    "https://youtu.be/yggfhAehczA?si=NmCpuWvBsvBdZMe4",
    "https://youtu.be/upNso2hsfLw?si=K9YN0-fO_fca5gyX",
    "https://youtu.be/s9ecSf20ZkE?si=yOOwxBNatI-ZS34S"
  ];

  return (
    <div className="container mx-auto px-2 sm:px-4 py-8">
      <div className="flex justify-center border-b mb-8">
        <TabButton
          active={activeTab === "photos"}
          onClick={() => setActiveTab("photos")}
          icon={Image}
        >
          Photos
        </TabButton>
        <TabButton
          active={activeTab === "videos"}
          onClick={() => setActiveTab("videos")}
          icon={Play}
        >
          Videos
        </TabButton>
      </div>

      <div className="mt-6">
        {activeTab === "photos" ? (
          <PhotoGrid photos={photos} copyPhotos={copyPhotos} />
        ) : (
          <VideoGrid videos={videos} />
        )}
      </div>
    </div>
  );
};

export default Media;